import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  MatError,
  MatFormField,
  MatLabel,
  MatSuffix,
} from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiServiceService } from '../api-service.service';
import { SharedValidators } from '../shared/validators/shared-validators';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatError,
    MatFormField,
    MatInputModule,
    MatLabel,
    MatSuffix,
    MatIconModule,
  ],
})
export class LoginPageComponent implements OnInit {
  projectName = environment.projectName;
  env = environment.env;

  loginForm: FormGroup = this.formBuilder.group({});
  forgotPasswordForm: FormGroup = this.formBuilder.group({});
  fieldTextType = false;
  isForgotPassword = false;
  userPermission = [];

  constructor(
    private formBuilder: FormBuilder,
    public apiMicroservice: ApiServiceService,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit() {
    this.spinner.hide();
    this.setLoginForm();
    this.setForgotPasswordForm();
    this.clearSession();
  }

  setLoginForm() {
    this.loginForm = this.formBuilder.group({
      email: [
        '',
        [
          SharedValidators.requiredAndNoEmptySpaces,
          SharedValidators.validEmail,
        ],
      ],
      password: [
        '',
        [
          SharedValidators.requiredAndNoEmptySpaces,
          SharedValidators.minLengthRequired(8),
        ],
      ],
    });
  }

  setForgotPasswordForm() {
    this.forgotPasswordForm = this.formBuilder.group({
      email: [
        '',
        [
          SharedValidators.requiredAndNoEmptySpaces,
          SharedValidators.validEmail,
        ],
      ],
    });
  }

  clearSession() {
    sessionStorage.clear();
    localStorage.clear();
  }

  onLogin() {
    if (this.loginForm.valid) {
      this.spinner.show();
      const payLoadData = this.loginForm.value;
      const data = {
        userEmail: payLoadData.email,
        password: payLoadData.password,
      };
      this.apiMicroservice.userLogin(data).subscribe(
        (res) => {
          this.spinner.hide();
          if (res.status) {
            sessionStorage.setItem(
              'token',
              this.apiMicroservice.encryptData(res.token)
            );
            sessionStorage.setItem(
              'userRefId',
              this.apiMicroservice.encryptData(res.data.id)
            );
            sessionStorage.setItem(
              'userFullName',
              this.apiMicroservice.encryptData(res.data.fullName)
            );
            sessionStorage.setItem(
              'userRole',
              this.apiMicroservice.encryptData(res.data.userRole)
            );
            sessionStorage.setItem(
              'email',
              this.apiMicroservice.encryptData(res.data.email)
            );
            sessionStorage.setItem(
              'userName',
              this.apiMicroservice.encryptData(res.data.userName)
            );
            sessionStorage.setItem(
              'roleType',
              this.apiMicroservice.encryptData(res.data.roleType) || ''
            );
            sessionStorage.setItem(
              'groupName',
              this.apiMicroservice.encryptData(res.data.groupId?.groupName) ||
                ''
            );
            sessionStorage.setItem(
              'groupId',
              this.apiMicroservice.encryptData(res.data.groupId?._id) || ''
            );
            sessionStorage.setItem(
              'hierarchyLevel',
              res.data.hierarchyLevel || res.data.hierarchyLevel === 0
                ? this.apiMicroservice.encryptData(
                    res.data.hierarchyLevel.toString()
                  )
                : ''
            );
            sessionStorage.setItem(
              'userPermission',
              this.apiMicroservice.encryptData(
                JSON.stringify(res.data.userPermission)
              )
            );

            this.userPermission = res.data.userPermission;

            if (!this.userPermission || this.userPermission.length === 0) {
              this.apiMicroservice.openSnackbar(
                "User doesn't have any permissions!"
              );
            } else {
              let hasPermission = false;

              for (const element of this.userPermission) {
                if (
                  element.pageName === 'Device Dashboard' &&
                  element.view === true
                ) {
                  this.apiMicroservice.redirect('device-dashboard');
                  hasPermission = true;
                  break;
                } else if (
                  element.pageName === 'Ticket Dashboard Page' &&
                  element.view === true
                ) {
                  this.apiMicroservice.redirect('ticket-dashboard-page');
                  hasPermission = true;
                  break;
                } else if (
                  element.pageName === 'My AIS 140 Tickets' &&
                  element.view === true
                ) {
                  this.apiMicroservice.redirect('ais140-ticket-list');
                  hasPermission = true;
                  break;
                } else if (
                  element.pageName === 'Government Servers' &&
                  element.view === true
                ) {
                  this.apiMicroservice.redirect('govt-servers');
                  hasPermission = true;
                  break;
                } else if (
                  element.pageName === 'FOTA Batch' &&
                  element.view === true
                ) {
                  this.apiMicroservice.redirect('fota-batch-list');
                  hasPermission = true;
                  break;
                } else if (
                  element.pageName === 'OTA Batch' &&
                  element.view === true
                ) {
                  this.apiMicroservice.redirect('Ota-batch-list');
                  hasPermission = true;
                  break;
                } else if (
                  element.pageName === 'Device Model' &&
                  element.view === true
                ) {
                  this.apiMicroservice.redirect('device-model-list');
                  hasPermission = true;
                  break;
                } else if (
                  element.pageName === 'Dealer FOTA' &&
                  element.view === true
                ) {
                  this.apiMicroservice.redirect('dealer-fota');
                  hasPermission = true;
                  break;
                } else if (
                  element.pageName === 'Dispatch Device' &&
                  element.view === true
                ) {
                  this.apiMicroservice.redirect('dispatch-device-list');
                  hasPermission = true;
                  break;
                } else if (
                  element.pageName === 'AIS140 Ticket Status Update Logs' &&
                  element.view === true
                ) {
                  this.apiMicroservice.redirect('ais140-tml-api-logs');
                  hasPermission = true;
                  break;
                } else if (
                  element.pageName === 'AIS140 Ticket TML Request Logs' &&
                  element.view === true
                ) {
                  this.apiMicroservice.redirect('ais140-api-req-logs');
                  hasPermission = true;
                  break;
                } else if (
                  element.pageName === 'AIS140 Ticket AEPL Response Logs' &&
                  element.view === true
                ) {
                  this.apiMicroservice.redirect('ais140-api-res-logs');
                  hasPermission = true;
                  break;
                }
                // else if (
                //   element.pageName === "Vehicle EOL Batch" &&
                //   element.view === true
                // ) {
                //   this.apiMicroservice.redirect("vehicle-eol-batch");
                //   hasPermission = true;
                //   break;
                // }
                else if (
                  element.pageName === 'SIM Data Details' &&
                  element.view === true
                ) {
                  this.apiMicroservice.redirect('sim-data-details');
                  hasPermission = true;
                  break;
                } else if (
                  element.pageName === 'User Management' &&
                  element.view === true
                ) {
                  this.apiMicroservice.redirect('user-management');
                  hasPermission = true;
                  break;
                } else if (
                  element.pageName === 'User Profile' &&
                  element.view === true
                ) {
                  this.apiMicroservice.redirect('profile');
                  hasPermission = true;
                  break;
                }
              }

              if (!hasPermission) {
                this.apiMicroservice.openSnackbar(
                  "User doesn't have any permissions!"
                );
              }
            }

            this.spinner.hide();
          }
        },
        (ERROR: HttpErrorResponse) => {
          this.spinner.hide();
          this.apiMicroservice.openSnackbar(ERROR.error.message);
        }
      );
    } else {
      SharedValidators.markAllAsTouched(this.loginForm);
    }
  }

  onForgotPassword() {
    if (this.forgotPasswordForm.valid) {
      this.spinner.show();
      const payload = this.forgotPasswordForm.value;
      const data = {
        customerEmail: payload.email,
      };
      this.apiMicroservice.loginReset(data).subscribe(
        (res) => {
          this.spinner.hide();
          if (res.status) {
            this.apiMicroservice.openSnackbar(
              'Password reset link sent to your email.'
            );
            this.toggleForm(); // Switch back to login form after success
          } else {
            this.apiMicroservice.openSnackbar(
              'Email is not registered. Enter a valid email!'
            );
          }
        },
        (ERROR: HttpErrorResponse) => {
          this.spinner.hide();
          this.apiMicroservice.openSnackbar(ERROR.error.message);
        }
      );
    } else {
      SharedValidators.markAllAsTouched(this.forgotPasswordForm);
    }
  }

  toggleForm() {
    this.isForgotPassword = !this.isForgotPassword;
    this.setLoginForm();
    this.setForgotPasswordForm();
  }

  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }
}
